import PropTypes from 'prop-types';
import PropsType from 'props-type';

const propTypes = {
  direction: PropTypes.oneOf(['bottom', 'top'] as const),
};

const defaultProps = {
  direction: 'bottom' as const,
};

type TriangleIconProps = PropsType<typeof propTypes, typeof defaultProps>;

function TriangleIcon({ direction }: TriangleIconProps) {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d={
          direction === 'bottom'
            ? 'M7.89495 12L3 5H12.7899L7.89495 12Z'
            : 'M7.89495 4L3 11H12.7899L7.89495 4Z'
        }
        fill="#424242"
        fillRule="evenodd"
      />
    </svg>
  );
}

TriangleIcon.propTypes = propTypes;
TriangleIcon.defaultProps = defaultProps;

export default TriangleIcon;
